function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.05,2.5A13.55,13.55,0,1,0,29.6,16.05,13.57,13.57,0,0,0,16.05,2.5Zm0,25.6a12.05,12.05,0,1,1,12.05-12A12.07,12.07,0,0,1,16.05,28.1Zm4.47-13a.74.74,0,0,1,.13,1.05.75.75,0,0,1-.59.29.74.74,0,0,1-.46-.16,5.77,5.77,0,0,0-7.1,0,.75.75,0,1,1-.92-1.18A7.27,7.27,0,0,1,20.52,15.09Zm2.89-2.85a.76.76,0,0,1,.12,1.06.77.77,0,0,1-1.06.12,10.21,10.21,0,0,0-6.34-2.22H16a10.24,10.24,0,0,0-6.35,2.22.76.76,0,0,1-.47.16.77.77,0,0,1-.59-.28.76.76,0,0,1,.12-1.06A11.81,11.81,0,0,1,16.06,9.7h.08A11.73,11.73,0,0,1,23.41,12.24Zm-4.79,7.85a2.57,2.57,0,1,1-2.57-2.58A2.57,2.57,0,0,1,18.62,20.09Z",
  fill: "#33ba69"
});

var SvgSiteIcon = function SvgSiteIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSiteIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/site_icon.71555210.svg";
export { ForwardRef as ReactComponent };